import { useMutation } from '@tanstack/react-query';
import featureFlags from 'services/featureFlags.ts';
import useAuth from '../../hooks/useAuth.ts';
import { apiFetch } from '../../utils/apiUtils.ts';

interface SubmitConfigBody {
  message: string;
  campaign_version: number;
  iteration_version: number;
}

export interface SubmitConfigVariables {
  teamId: string;
  iterationId: string;
  campaignId: string;
  dryRun?: boolean;
}

export default function useSubmitConfig() {
  const { tokens } = useAuth();

  return useMutation({
    mutationFn: async ({
      teamId,
      iterationId,
      campaignId,
      dryRun,
    }: SubmitConfigVariables) => apiFetch<SubmitConfigBody>({
      path: `team/${teamId}/campaign/${campaignId}/iteration/${iterationId}/submitConfig`,
      method: 'PUT',
      accessToken: String(tokens.accessToken),
      body: featureFlags.dryRunEnabled ? { dry_run: dryRun } : undefined,
    }),
  });
}
